module.exports = __webpack_public_path__ + "static/img/default.2629291.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/units/d_tree2_adult/default.png
// module id = Uw3O
// module chunks = 1